import { useState, useEffect } from 'react';
import genresMock from './mock';

interface Genre {
  id: string;
  label: string;
  name: string;
  image: string;
  link: string;
}

type Genres = Array<Genre>;

interface GenresDataCreator<Loading, Error, Data> {
  loading: Loading;
  error: Error;
  data: Data;
}

type UseFeaturedGenresLoading = GenresDataCreator<true, null, null>;
type UseFeaturedGenresError = GenresDataCreator<false, Error, null>;
type UseFeaturedGenresSuccess = GenresDataCreator<false, null, Genres>;

export type UseFeaturedGenres =
  | UseFeaturedGenresLoading
  | UseFeaturedGenresError
  | UseFeaturedGenresSuccess;

const useFeaturedGenres = (): UseFeaturedGenres => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState<Genres>();

  useEffect(() => {
    /* TODO: replace emulation with real request */
    setTimeout(() => {
      setData(genresMock);
      setLoading(false);
    }, 0);
  }, []);

  if (loading) {
    return {
      loading,
      error: null,
      data: null,
    };
  }

  if (!data) {
    return {
      loading: false,
      error: new Error('no data is available'),
      data: null,
    };
  }

  return {
    loading: false,
    error: null,
    data,
  };
};

export default useFeaturedGenres;
